<template>
  <base-index
    ref="baseIndex"
    :columns="columns"
    :resourceName="resourceName"
    :pk="pk"
    :disabledFilterButton="false"
    :breadcrumbs="breadcrumbs"
  >
  </base-index>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      resourceName: "push_advertisments",
      pk: "push_advertisments_id",
      columns: [
        {
          value: "title",
          text: "通知タイトル",
          filter: true,
        },
        {
          value: "body",
          text: "通知本文",
          filter: true,
        },
        // {
        //   value: "image",
        //   text: "通知画像"
        // },
        {
          value: "target_num",
          text: "送信人数",
          filter: true
        },
        {
          value: "conditions",
          text: "通知絞り込み条件"
        },
        {
          value: "sent_at",
          text: "送信日時",
          filter: true,
          type: "datetime"
        },
        {
          value: "sent",
          text: "ステータス",
          filter: true,
          width: 80,
          type: 'select',
          optionType: "common/publish"
        }
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "Push通知一覧",
          disabled: true
        }
      ];
    }
  }
};
</script>
